import { BaseCompanyGrowingUrl, BaseCompanySellingUrl, BaseCompanyManagementUrl } from '@/menus/__base';
import { GrowingMenu, SellingMenu, ManagementMenu } from '@/menus/company';

export const useGetCompanyMenu = () => {
  let pathname = window.location.pathname;
  if (pathname.startsWith(BaseCompanyGrowingUrl)) {
    return GrowingMenu;
  } else if (pathname.startsWith(BaseCompanySellingUrl)) {
    return SellingMenu;
  } else if (pathname.startsWith(BaseCompanyManagementUrl)) {
    return ManagementMenu;
  }
  return [];
};
